export const getPickerStyles = (
  isExcluded: boolean,
  isDisabledVisually: boolean
) => {
  const defaultColor = isDisabledVisually ? "text.disabled" : "text.primary";
  const defaultBgColor = isExcluded ? "#EAF4E7" : "transparent";
  const hoverBgColor = isExcluded ? "error.main" : "info.dark";

  return {
    bgcolor: defaultBgColor,
    color: defaultColor,
    fontWeight: 400,
    borderRadius: "4px",

    "&:hover": {
      bgcolor: hoverBgColor,
    },

    "&.Mui-selected": {
      bgcolor: defaultBgColor,
      color: "text.primary",
      fontWeight: 400,

      "&:hover": {
        bgcolor: hoverBgColor,
      },
    },
  };
};

export const getPreviewStyles = (excludedColor = "#EAF4E7") => ({
  bgcolor: excludedColor,
  borderRadius: "4px",
  cursor: "default !important",

  "&:hover": {
    bgcolor: excludedColor,
  },

  "&.Mui-selected": {
    bgcolor: excludedColor,
    color: "text.primary",
    fontWeight: 400,

    "&:hover": {
      bgcolor: excludedColor,
    },
  },
});

export const defaultPreviewStyles = {
  borderRadius: "4px",
  cursor: "default !important",

  "&:hover": {
    bgcolor: "transparent",
  },

  "&.Mui-selected": {
    bgcolor: "transparent",
    color: "text.primary",
    fontWeight: 400,

    "&:hover": {
      bgcolor: "transparent",
    },
  },
};
